import React from 'react';
import { asyncComponent, retryImport } from '@ohif/ui';

import ConnectedAnalysisReport from './ConnectedAnalysisReport.js';
import init from './init.js';

// const OHIFVTKViewport = asyncComponent(() =>
//   retryImport(() =>
//     import(/* webpackChunkName: "OHIFVTKViewport" */ './OHIFVTKViewport.js')
//   )
// );

// import LabellingFlow from '../../components/Labelling/LabellingFlow';

// import ConnectedMeasurementTable from './ConnectedAnalysisReport.js';

export default {
  /**
   * Only required property. Should be a unique value across all extensions.
   */
  id: 'analysis-report',
  get version() {
    return window.version;
  },
  preRegistration({ servicesManager, commandsManager, configuration = {} }) {
    init({ servicesManager, commandsManager, configuration });
  },
  getPanelModule({ servicesManager, commandsManager }) {
    return {
      menuOptions: [
        {
          icon: 'th-large',
          label: 'AI分析结果',
          // from: 'from-analysis-report',
          target: 'analysis-report',
          // UI Hint; If the target panel is in a "disabled" state
          // isDisabled: studies => {
          //   return false;
          // },
          // Overrides `defaultContext`, if specified
          // context: ['ACTIVE_VIEWPORT:MAGIC'],
        },
      ],
      components: [
        {
          id: 'analysis-report',
          // component: ExtendedConnectedAnalysisReport,
          component: ConnectedAnalysisReport,
        },
      ],
      // defaultContext: ['VIEWER'],
      defaultContext: ['VIEWER'],
    };
  },

  // getViewportModule({ commandsManager, servicesManager }) {
  //   const ExtendedVTKViewport = props => (
  //     <div>2222222222222</div>
  //   );
  //   return withCommandsManager(ExtendedVTKViewport, commandsManager);
  // },
};
